import store from '../store';
import { getBackEndVars } from './paypal/getVariables';
var backEndVars = getBackEndVars();
export var getPromoCode = function () { return (!!backEndVars.promoCode ? backEndVars.promoCode : store.get('promoCode')); };
export var getIsPromoCodeValid = function () {
    return !!backEndVars.isPromoCodeValid ? backEndVars.isPromoCodeValid : store.get('isPromoCodeValid');
};
export var getValidPromoCode = function () {
    return !!getIsPromoCodeValid() && backEndVars.checkoutOffer === 'checkout' ? getPromoCode() : null;
};
export function handlePromoValidityResponse() {
    if (!!backEndVars.isPromoCodeValid) {
        store.set('promoCode', backEndVars.promoCode);
        store.set('isPromoCodeValid', backEndVars.isPromoCodeValid);
    }
    else if (!!store.get('isPromoCodeValid')) {
        var promoCode_1 = store.get('promoCode');
        document.querySelectorAll('.js-promo-label').forEach(function (label) { return (label.textContent = promoCode_1.toUpperCase()); });
    }
    else {
        document.querySelectorAll('.js-promo-label-container').forEach(function (label) { return label.classList.add('hidden'); });
    }
}
